import { render, staticRenderFns } from "./6_donationResult.vue?vue&type=template&id=b096e0e0"
import script from "./6_donationResult.vue?vue&type=script&lang=js"
export * from "./6_donationResult.vue?vue&type=script&lang=js"
import style0 from "./6_donationResult.vue?vue&type=style&index=0&id=b096e0e0&prod&lang=scss&module=true"
import style1 from "./6_donationResult.vue?vue&type=style&index=1&id=b096e0e0&prod&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports